import React from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroImg2 from '../components/HeroImg2';
import AboutContent from '../components/AboutContent';

// Import the about image from assets
import AboutImage from '../assets/about.jpg';

const About = () => {
  return (
    <div>
      <Navbar />
      <HeroImg2 heading="ABOUT." text="I'm a Full-Stack Developer" />

      {/* Add About Image */}
      <div className="about-image-container">
        <img src={AboutImage} alt="About Me" className="about-image" />
      </div>

      <AboutContent />
      <Footer />
    </div>
  );
};

export default About;
